"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateFeedMembers = exports.setPendingInvitations = exports.removePendingInvitation = exports.rejectMemberInvitationIntoFeed = exports.kickMemberFromFeed = exports.inviteMemberIntoFeed = exports.getFeedMembers = exports.cancelMemberInvitationIntoFeed = exports.addPendingInvitation = exports.acceptMemberInvitationIntoFeed = void 0;
var types = _interopRequireWildcard(require("./types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var acceptMemberInvitationIntoFeed = _feed => ({
  type: types.ACCEPT_MEMBER_INVITATION_INTO_FEED,
  _feed
});
exports.acceptMemberInvitationIntoFeed = acceptMemberInvitationIntoFeed;
var addPendingInvitation = _invitation => ({
  type: types.ADD_PENDING_INVITATION,
  _invitation
});
exports.addPendingInvitation = addPendingInvitation;
var cancelMemberInvitationIntoFeed = _feed => ({
  type: types.CANCEL_MEMBER_INVITATION_INTO_FEED,
  _feed
});
exports.cancelMemberInvitationIntoFeed = cancelMemberInvitationIntoFeed;
var getFeedMembers = _feed => ({
  type: types.GET_FEED_MEMBERS,
  _feed
});
exports.getFeedMembers = getFeedMembers;
var inviteMemberIntoFeed = (_feed, _users) => ({
  type: types.INVITE_MEMBERS_INTO_FEED,
  _feed,
  _users
});
exports.inviteMemberIntoFeed = inviteMemberIntoFeed;
var kickMemberFromFeed = (_feed, _user) => ({
  type: types.KICK_MEMBER_FROM_FEED,
  _feed,
  _user
});
exports.kickMemberFromFeed = kickMemberFromFeed;
var rejectMemberInvitationIntoFeed = _feed => ({
  type: types.REJECT_MEMBER_INVITATION_INTO_FEED,
  _feed
});
exports.rejectMemberInvitationIntoFeed = rejectMemberInvitationIntoFeed;
var removePendingInvitation = _invitation => ({
  type: types.REMOVE_PENDING_INVITATION,
  _invitation
});
exports.removePendingInvitation = removePendingInvitation;
var setPendingInvitations = _invitations => ({
  type: types.SET_PENDING_INVITATIONS,
  _invitations
});
exports.setPendingInvitations = setPendingInvitations;
var updateFeedMembers = exports.updateFeedMembers = function updateFeedMembers(_feed, _deletedUsers, _addedUsers) {
  var isNewFeed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return {
    type: types.UPDATE_FEED_MEMBERS,
    _feed,
    _deletedUsers,
    _addedUsers,
    isNewFeed
  };
};